<app-header-style-two></app-header-style-two>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/">Accueil</a></li>
                <li>Evènements</li>
            </ul>
            <h2>{{event?.title}}</h2>
        </div>
    </div>
</div>

<div class="events-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="events-details-header">
                    <a routerLink="/events" class="back-all-events"><i class='bx bx-chevrons-left'></i> Retour aux évènements</a>
                    <h3>{{event?.title}} </h3>
                    <!-- <ul class="events-info-meta d-none">
                        <li><i class="flaticon-timetable"></i> 10 Novembere 2022</li>
                        <li><i class="far fa-clock"></i> 10h - 12h</li>
                    </ul> -->
                    <div class="events-meta">
                        <ul>
                            <!-- <li>
                                <i class='bx bx-folder-open'></i>
                                <span>Groupe</span>
                                <a href="#">BAC</a>
                            </li> -->
                            <li *ngIf="event.nextEventDate !== '#na'">
                                <i class='bx bx-group'></i>
                                <span>Date</span>
                                {{event?.nextEventDate}}
                            </li>
                            <li *ngIf="event.nextEventHour !== '#na'">
                                <i class='bx bx-calendar'></i>
                                <span>Heure</span>
                                {{event?.nextEventHour}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="events-details">
                    <div class="events-details-image">
                        <img src="{{event.mainBanner}}" style="height: 70% !important;" alt="image">
                    </div>
                    <div class="events-details-desc">
                        <!-- <pre>
                            <p style="text-align: justify; color: black" >{{event?.description}}</p>
                        </pre> -->
                        <div id="desc" [innerHTML]="elementHtml.innerHTML | sanitizeHtml" style="text-align: justify;"></div>

                        <div *ngIf="event.nextEvent !== '#na'" class="mt-2">
                            <span class="nextEvent">Prochain rendez-vous: </span> <b>{{event.nextEvent}}</b>
                        </div>
                    </div>

                    <!-- PASNDED -->
                    <!-- <div class="events-info-links">
                        <a href="#" target="_blank">+ Google Calendar</a>
                        <a href="#" target="_blank">+ iCal Export</a>
                    </div> -->
                    <!-- <div class="ednuv-post-navigation">
                        <div class="prev-link-wrapper">
                            <div class="info-prev-link-wrapper">
                                <a routerLink="/single-events">
                                    <span class="image-prev">
                                        <img src="assets/img/events/events2.jpg" alt="image">
                                        <span class="post-nav-title">Prev</span>
                                    </span>
                                    <span class="prev-link-info-wrapper">
                                        <span class="prev-title">Don't buy a tech gift until you read these rules</span>
                                        <span class="meta-wrapper">
                                            <span class="date-post">January 21, 2020</span>
                                        </span>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="next-link-wrapper">
                            <div class="info-next-link-wrapper">
                                <a routerLink="/single-events">
                                    <span class="next-link-info-wrapper">
                                        <span class="next-title">The golden rule of buying a phone as a gift</span>
                                        <span class="meta-wrapper">
                                            <span class="date-post">January 21, 2020</span>
                                        </span>
                                    </span>
                                    <span class="image-next">
                                        <img src="assets/img/events/events3.jpg" alt="image">
                                        <span class="post-nav-title">Next</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div> -->
                    <!-- FINPASDEN -->
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <aside class="widget-area">
                    <!-- <div class="widget widget_events_details">
                        <h3 class="widget-title">Détails</h3>
                        <ul>
                            <li><span>Début:</span> December 15, 2020 8:00</li>
                            <li><span>Fin:</span> December 19, 2020 8:00</li>
                            <li><span>Groupe:</span> <a routerLink="/events">Design</a></li>
                        </ul>
                    </div> -->
                    <div class="widget widget_events_details">
                        <h3 class="widget-title">Organisateur</h3>
                        <ul>
                            <li><span>Téléphone:</span> <a href="tel:+22997213717">+229 97 213 717</a></li>
                            <li><span>E-mail:</span> <a href="mailto:hello@ednuv.com">hello@cacebenin.bj</a></li>
                            <li><span>Site web:</span> <a href="https://www.cacebenin.bj" target="_blank">https://www.cacebenin.bj</a></li>
                        </ul>
                    </div>
                    <div class="widget widget_instagram">
                        <h3 class="widget-title">Gallerie</h3>
                        <ul>
                            <li *ngFor="let image of _album; let i=index">
                                <div class="single-gallery-item mb-30">
                                    <img [src]="image.thumb" (click)="open(i)" />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="widget widget_contact">
                        <div class="text">
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <span>Emergency</span>
                            <a href="tel:+098798768753">+0987-9876-8753</a>
                        </div>
                    </div> -->
                </aside>
            </div>
        </div>
    </div>
</div>